<template>
  <Layout>
    <TableView :action-filter="i=>!i.logSeqResend" :actions="['재전송']" slot="content" @nextList="getList()" :columns="columns" :filters="filter" @action="action" :list="list"
      :server-total="total" minWidth="900px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-250px ps-11"
          :placeholder="$t('제목, 받는사람, 보낸사람')" title="제목, 받는사람, 보낸사람">
      </div>
      <b-button variant="light-primary" class="me-3" v-b-modal.상세>
        <b-icon icon="filter" /> {{ $t('상세') }}
      </b-button>
    </TableView>

    <ModalForm id="view" :title="detailTitle" :data="sel" centered size="lg">
      <span class="modal-fileNm" v-if="fileList" v-for="file in fileList" :key="file">
        <a style="color:#009ef7 !important;" :href="$url(file.url, true)" >{{ file.filename }}</a> <em class="ms-5"></em>
      </span>
      <div class="modal-html mt-8"></div>
    </ModalForm>

    <ModalForm id="상세" @cancel="detailSearch({})" modal-class="compact" ok-title="검색" cancel-title="초기화"
      :data="detail" close-on-backdrop ref="detailSearch" @action="detailSearch"
      :spec="[
        { label: '전송일', form: 1, type: 'date-between', key: 'sendDt' }, ]" >
    </ModalForm>

  </Layout>
</template>
<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

function unEscape(htmlStr) {
  htmlStr = htmlStr.replace(/&lt;/g , "<");	 
  htmlStr = htmlStr.replace(/&gt;/g , ">");     
  htmlStr = htmlStr.replace(/&quot;/g , "\"");  
  htmlStr = htmlStr.replace(/&#39;/g , "'");   
  htmlStr = htmlStr.replace(/&amp;/g , "&");
  return htmlStr;
}

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    sel: {},
    list: [], fileList:[],
    total: 0,
    columns: [
      { key: 'successNm', label: '성공여부', renderer: item => `<b class="badge badge-light-${item.successClass}">${item.successNm}</b>`, style: { textAlign: 'center' } },
      { key: 'sendDt', label: '전송일', renderer: item => `${item.regDt.f('datetime-local')}`, style: { textAlign: 'center' } },
      { key: 'notiNm', label: '알림분류', style: { textAlign: 'center' } },
      { key: 'subject', label: '제목', style: { textAlign: 'center' } },
      { key: 'custName', label: '조직', required, style: { textAlign: 'center' } },/*  */
      { key: 'rcvrNm', label: '받는사람', renderer: item =>`${item.toName} (${item.toEmail})`, required, style: { textAlign: 'center' } },
      { key: 'sndrNm', label: '보낸사람', renderer: item =>`${item.fromName} ${item.fromEmail ? '('+item.fromEmail+')' : ''}`, required, style: { textAlign: 'center' } },
      { key: 'fileCnt', label: '첨부파일', renderer: (item, scope) =>`${item.fileCnt>0 ? scope.$parent.$parent.clipIcon() + '('+item.fileCnt+')' : ''}`, required, style: { textAlign: 'center' } },
    ],
    listParams: { searchKeyword:'', notiCd:null, successYn:null },
    filter: [
    { key:'successYn', label:'성공여부', cd:'SUCCESS' },
    { key:'notiCd', label:'알림분류', cd:'NOTI' },
    ],
    selected: 'loginDate',
    detailTitle: '',
    options: [ ],
    detail: { sendDt: ['', '']},
  }),
  created() { this.getList(); },
  mounted() { },
  beforeDestroy() { },
  computed: {},
  watch: { listParams: { deep: true, handler: 'getList' } },
  methods: {
    clipIcon() { // 공통으로 사용되지는 않아 공통에서 페이지의 함수로 옮깁니다.
      return `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1280.000000 1280.000000" preserveAspectRatio="xMidYMid meet"><metadata>Created by potrace 1.15, written by Peter Selinger 2001-2017</metadata><g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"fill="#000000" stroke="none"><path d="M2800 12679 c-282 -20 -586 -121 -833 -277 -380 -238 -672 -558 -857 -937 -111 -225 -159 -393 -181 -624 -26 -272 40 -576 179 -821 48 -85 5566 -8598 5733 -8845 271 -400 570 -673 934 -852 584 -286 1260 -251 1968 103 169 85 240 128 382 234 621 461 981 960 1103 1530 24 115 26 144 27 355 0 248 -7 299 -66 522 -54 206 -165 461 -292 669 -30 49 -391 607 -803 1239 -413 633 -1395 2142 -2183 3355 -1045 1607 -1447 2218 -1483 2252 -189 182 -538 23 -540 -246 0 -42 6 -78 20 -108 18 -41 1534 -2376 3684 -5676 406 -623 758 -1168 783 -1211 105 -183 195 -407 232 -581 14 -66 18 -128 17 -280 0 -177 -3 -204 -26 -290 -49 -181 -135 -350 -268 -528 -129 -174 -415 -434 -640 -584 -165 -109 -437 -233 -630 -287 -207 -57 -465 -72 -643 -37 -361 70 -687 301 -969 686 -94 128 -5754 8862 -5792 8938 -20 39 -48 111 -63 159 -23 78 -26 104 -26 233 0 188 25 289 118 475 177 354 508 655 846 769 222 74 491 75 708 1 167 -56 342 -177 451 -310 77 -93 4329 -6652 4396 -6780 163 -310 158 -541 -16 -715 -98 -98 -320 -237 -450 -282 -218 -75 -444 16 -625 252 -23 30 -644 987 -1380 2125 -1519 2350 -1500 2322 -1551 2363 -111 92 -296 81 -411 -23 -96 -86 -137 -220 -101 -327 16 -44 2808 -4374 2907 -4508 201 -269 455 -442 731 -497 98 -19 301 -19 411 1 257 46 571 203 801 400 265 226 418 544 418 864 0 229 -81 515 -210 744 -70 123 -4301 6647 -4371 6738 -229 302 -568 512 -950 590 -89 18 -311 42 -364 38 -11 0 -67 -4 -125 -9z"/></g></svg>`
    },
    async action({ action, item, form }) {
      if (action == '재전송') {
        const { msg } = await this.$api('adm/log/email/resendEmail', {logSeq: item.logSeq}, {defaultProgress:99});
        await this.$alert(msg);
        item.logSeqResend = 'logSeqResend';
      }
      else if (!form && ['view'].includes(action)) {
        this.sel = item;        
        const selLogSeq = this.sel.logSeq;
        const res = await this.$api('adm/log/email/selectEmailLog', { logSeq : selLogSeq} );
        this.detailTitle = res.data.subject;
        this.fileList = res.data.fileList;
        setTimeout(() => {
          const detailHtml = document.querySelector('.modal-html');
          if (detailHtml) {            
            detailHtml.innerHTML = unEscape(res.data.body);
            detailHtml.style.display = 'flex';
            detailHtml.style.justifyContent = 'center';
          }
        }, 100);
        return this.$nextTick(() => this.$bvModal.show(action));
      }
    },
    async getList(reset) {
      if (reset != undefined) this.list = [];
      const {list, parameter:{total}} = await this.$api('adm/log/email/selectEmailLogList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.total = total;
      this.list.push(...list);
    },
    detailSearch({ form }) {
      setTimeout(() => document.activeElement.blur(), 500);
      if (form) this.detail.sendDt = form.sendDt;
      const check = this.detail.sendDt.join('');
      if (!form && !check) return;
      else if (!form) this.detail.sendDt = ['', ''];
      else if (form && !check) return this.$alert(this.$t('전송일이 지정되지 않았습니다.'));
      else if (form && form.sendDt[0] && form.sendDt[1] && form.sendDt[0] > form.sendDt[1]) return this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
      this.listParams.sendDtFrom = this.detail.sendDt[0];
      this.listParams.sendDtTo = this.detail.sendDt[1];
    },
  },
}
</script>
